import { useEffect, useState } from "react";
import serviceSales, { Subscription, SubscriptionEvent } from "../../services/service-sales";
import { formatDate } from "../../util";
import { ServiceUser } from "../../services/service-user";
import { NotificationManager } from "react-notifications"; 
import { Loading } from "../../components/shared";
import SubscriptionSettings from "./SubscriptionSettings";
import { useTranslation } from 'react-i18next';

const RecommendedSubscription = () => {
  const [subscription, setSubscription] = useState<Subscription>();
  const [loading, setLoading] = useState(false);
  const [allUsers, setAllUsers] = useState(new Map<string, string>());
  const [t] = useTranslation('settings', { keyPrefix: 'salesSettings.subscriptions'});

  useEffect(() => {
    (async () => {
    setLoading(true);
      try {
        const response = await serviceSales.fetchRecommendedSubscription();
        setSubscription(response);
        const userIds = Array.from((response?.history ?? [])
          .map((event: SubscriptionEvent) => event.user)
          .filter((x:string) => !!x)
          .reduce((set: Set<string>, id: string) => set.add(id), new Set()));

        const users = await Promise.all(userIds.map(id => ServiceUser.getUserById(id)));
        const userById = users.reduce((map: Map<string, string>, user: any) => map.set(user._id, `${user.name} <${user.email}>`), new Map());
        setAllUsers(userById);  
      } catch (e) {        
        NotificationManager.error((e as Error).toString(), t('notification.error.couldNotFetchQuotations', 'Kunde inte hämta förfrågningar'));
        console.error(e);
      }
      setLoading(false);
    })();
  }, [])

  const onSubscribe = async () => {
    const subscription = await serviceSales.orderRecommendedSubscription();
    setSubscription(subscription);
    NotificationManager.success(t('recommended.notification.success.ordered', 'Prenumerationen kommer förnyas automatiskt.'), t('notification.success.title', 'Sparat'));
  }

  const onCancel = async () => {
    const subscription = await serviceSales.cancelRecommendedSubscription();
    setSubscription(subscription);
    NotificationManager.success(t('notification.success.canceled', 'Prenumerationen kommer avslutas efter nuvarande fakturaperiod (den {{endDate}})', { endDate: formatDate(subscription?.active?.endDate) }), t('notification.success.title', 'Sparat'));
  }

  if (loading) {
    return <Loading type="inline" />
  }

  return <SubscriptionSettings 
    productName={t('recommended.productName', 'Accurator Prio')}
    purchasePage={t('recommended.purchasePageName', 'Marknadsföring')}
    subscription={subscription}
    loading={loading}
    onSubscribe={onSubscribe}
    onCancel={onCancel}
    allUsers={allUsers}
  />;
}

export default RecommendedSubscription;